import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import _ from 'lodash';

import { INTEGRATIONS, beautifyHost, prepareUrl } from '../../../util/integrations';
import { windowLocation } from '../../../util/url';
import integrationsIcon from '../../../assets/images/integrations/integrations.svg';
import checkedIcon from '../../../assets/images/integrations/connection-checked.svg';
import uncheckedIcon from '../../../assets/images/integrations/connection-unchecked.svg';
import linkIcon from '../../../assets/img/link.svg';
import unlinkIcon from '../../../assets/img/unlink.svg';

import Close from '../../../assets/img/close.svg';

import './IntegrationsDropdown.scss';

export class IntegrationsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: props.visible
    };
  }

  onClose = (event, propagate) => {
    if (event) {
      event.stopPropagation();
    }

    this.setState({ isOpened: false });

    if (this.props.onClose && propagate) {
      this.props.onClose();
    }
  };

  onButtonClick = () => {
    if (!this.state.isOpened) {
      this.setState({ isOpened: true });
    }
  };

  handleClickIntegrationButton = (integration) => {
    const { app, user } = this.props;
    if (integration.linked) {
      windowLocation() && windowLocation().replace(prepareUrl(integration.application, 'api/tenant/integration/switch', { accountId: integration.accountId, from: windowLocation().pathname }));
    } else {
      windowLocation() && windowLocation().replace(
        prepareUrl(INTEGRATIONS[integration.id].app, INTEGRATIONS[integration.id].connect, {
          ...INTEGRATIONS[integration.id].params,
          h: integration.host && !INTEGRATIONS[integration.id].params.cloud ? beautifyHost(integration.host) : undefined,
          connect: true,
          account: integration.accountId,
          user: user._id,
          path: windowLocation().pathname,
          from: app
        })
      );
    }
  }

  handleClickIntegrationLink = (integration) => {
    const { app, user } = this.props;
    windowLocation().replace(
      prepareUrl(INTEGRATIONS[integration].app, INTEGRATIONS[integration].login, {
        ...INTEGRATIONS[integration].params,
        account: user.selectedAccount,
        user: user._id,
        path: windowLocation().pathname,
        from: app
      })
    );
  }

  renderIntegrationButton = (integration) => {
    const { app, user } = this.props;
    const application = integration.application;
    const key = `${INTEGRATIONS[integration.id].name} / ${beautifyHost(integration[INTEGRATIONS[integration.id].field])}`;
    const selected = application === app && integration[INTEGRATIONS[integration.id].field] === user[INTEGRATIONS[integration.id].field];
    return (
      <div key={key} data-app={key} onClick={() => !selected && this.handleClickIntegrationButton(integration)} className={'integration_link' + (selected ? ' selected' : '')}>
        <div>
          <img className="connection_icon" src={INTEGRATIONS[integration.id].icon} alt="#"/>
          <strong>{INTEGRATIONS[integration.id].name}</strong>
          {beautifyHost(integration[INTEGRATIONS[integration.id].field])}
        </div>
        {
          integration.linked ? 
          <div><img className="connection_checkmark" src={selected ? checkedIcon : uncheckedIcon} alt="#"/></div> :
          <div className='btn btn-sm btn-icon btn-light-secondary'><img className="connection_link" src={linkIcon} alt="#"/></div>
        }
      </div>
    )
  }

  renderIntegrationLink = (integration) => {
    const application = integration.id;
    return (
      <div key={integration.id} data-app={integration.id} onClick={() => this.handleClickIntegrationLink(application)} className="integration_link">
        <div>
          <img className="connection_icon" src={INTEGRATIONS[application].icon} alt="#"/>
          <strong>{INTEGRATIONS[application].name}</strong>
        </div>
        <div className='btn btn-sm btn-icon btn-light-secondary'><img className="connection_link" src={linkIcon} alt="#"/></div>
      </div>
    )
  }

  render() {
    const { isOpened } = this.state;
    const { user } = this.props;

    const asanaConnection = _.find(user && user.integrations, { id: 'asana' });
    const azureConnection = _.find(user && user.integrations, { id: 'azure' });
    const jiraCloudConnection = _.find(user && user.integrations, { id: 'jira' });
    const jiraServerConnection = _.find(user && user.integrations, { id: 'jira-server' });
    const trelloConnection = _.find(user && user.integrations, { id: 'trello' });

    const notLinkedConnections = _.filter(user && user.integrations, c => !c.linked);

    const modal = (
      <Modal 
        keyboard={false}
        backdrop='static'
        show={isOpened}
        onHide={this.onClose}
        className="integrations_modal"
      >
        <Modal.Header>
          <Modal.Title>
            {this.props.title || 'Manage integrations'}
          </Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body className="integrations_list">
          {user.integrations &&
            <div className="integrations_group">
              <div className="integrations_group_title">Active connections</div>
              <div className="integrations_group_list">
                { _.filter(user.integrations, i => i.linked).map((integration) => {
                  return this.renderIntegrationButton(integration)
                })}
              </div>
            </div>
          }
          <div className="integrations_group">
            <div className="integrations_group_title">Add a new connection</div>
            <div className="integrations_group_list">
              {
                _.map(notLinkedConnections, this.renderIntegrationButton)
              }
              {
                jiraCloudConnection ?
                  !jiraCloudConnection.linked ? this.renderIntegrationButton(jiraCloudConnection) : undefined
                  : this.renderIntegrationLink({id: 'jira', application: 'jira', host: ''})
              }
              {
                jiraServerConnection ?
                  !jiraServerConnection.linked ? this.renderIntegrationButton(jiraServerConnection) : undefined
                  : this.renderIntegrationLink({id: 'jira-server', application: 'Jira Server / Datacenter', host: ''})
              }
              {
                azureConnection ?
                  !azureConnection.linked ? this.renderIntegrationButton(azureConnection) : undefined
                  : this.renderIntegrationLink({id: 'azure', application: 'azure', host: ''})
              }
              {
                trelloConnection ?
                  !trelloConnection.linked ? this.renderIntegrationButton(trelloConnection) : undefined
                  : this.renderIntegrationLink({id: 'trello', application: 'trello', email: ''})
              }
              {
                asanaConnection ?
                  !asanaConnection.linked ? this.renderIntegrationButton(asanaConnection) : undefined
                  : this.renderIntegrationLink({id: 'asana', application: 'asana', email: ''})
              }
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );

    let content;
    if (this.props.children) {
      const btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          ...btn.props,
          onClick: this.onButtonClick
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <div>
          <OverlayTrigger
            overlay={
              <Tooltip id="integrationsTooltip" className="tooltip_dark full_width">
                Choose between Jira, Trello, Azure DevOps or Asana
              </Tooltip>
            }
            placement="bottom"
          >
            <Button
              className='integrations_btn'
              variant='secondary'
              onClick={this.onButtonClick}
            >
              <img src={integrationsIcon} alt="" />Change Selected Connection
            </Button>
          </OverlayTrigger>
          {modal}
        </div>
      );
    }

    return content;
  }
}

IntegrationsDropdown.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    user: state.auth.user,
  };
};

export default connect(mapStateToProps)(IntegrationsDropdown);
